<template>
    <AuthStepBasicDialog :errorMessage="state.errorMessage">




        <template #icon>
            <PadlockIcon></PadlockIcon>
        </template>




        <template #title>
            New Password
        </template>
        <template #description>
            Please enter and confirm your new password
        </template>







        <template #form>
            <div class="d-flex flex-column align-center w-100">




                <CustomInput label="New Password" placeholder="Type your password" type="password" class="mb-5"
                    v-model="state.newPassword" :error-messages="v$.newPassword.$errors.map(e => e.$message)"
                    @blur="v$.newPassword.$touch()" />


                <CustomInput label="Confirm Password" placeholder="Type your password" type="password"
                    v-model="state.confirmPassword" :error-messages="v$.confirmPassword.$errors.map(e => e.$message)"
                    @blur="v$.confirmPassword.$touch()" />




                <button @click="resetPassword" :disabled="isResetting || v$.$invalid"
                    class="  button--primary rounded-pill text-15 weight-600 py-4 px-16 mt-5">
                    {{ isResetting ? 'Resetting...' : 'Reset Password' }}
                </button>





            </div>
        </template>






    </AuthStepBasicDialog>
</template>







<script lang="ts" setup>

import useVuelidate from '@vuelidate/core';
import forgotPasswordEvents from '@/Events/ForgotPassword';
import { ErrorResponse } from '@/interfaces/ErrorResponse';
import PadlockIcon from '@/icons/ResetPassword/Padlock.vue';
import { resetPasswordRules } from '@/utils/ValidationRules';
import CustomInput from '@/components/Common/CustomInput.vue';
import { ForgotPasswordService } from '@/api/services/ForgotPasswordService';
import { reactive, ref, provide, onMounted, onUnmounted, computed } from 'vue';
import AuthStepBasicDialog from '@/components/Auth/Common/Auth-Steps-Basic-Dialog.vue';




const dialogVisible = ref(false);
provide('openDialog', dialogVisible);




const state = reactive({
    newPassword: '',
    confirmPassword: '',
    errorMessage: '',
});
const rules = computed(() => resetPasswordRules(state.newPassword));
const v$ = useVuelidate(rules, state);




const isResetting = ref(false);
const verificationCode = ref('');








const openForgotPasswordDialog = () => {
    dialogVisible.value = true;
}
const closeForgotPasswordDialog = () => {
    dialogVisible.value = false;
}







const resetPassword = async () => {
    v$.value.$touch();
    if (v$.value.$invalid) {
        state.errorMessage = 'Please correct the errors.';
        return;
    }

    isResetting.value = true;
    state.errorMessage = '';

    try {
        const response = await ForgotPasswordService.resetPassword(verificationCode.value, state.newPassword);
        if (response.success) {
            forgotPasswordEvents.emit('forgot-password-password-reset-successfull');
            closeForgotPasswordDialog();
        } else {
            state.errorMessage = response.message;
        }
    } catch (error: ErrorResponse | any) {
        state.errorMessage = error.friendly_message;
    } finally {
        isResetting.value = false;
    }
};








const passwordResetCodeReceived = async (resetCode: string) => {
    openForgotPasswordDialog();
    verificationCode.value = resetCode;
};






onMounted(() => {
    forgotPasswordEvents.on('forgot-password-email-link-received', passwordResetCodeReceived);
});
onUnmounted(() => {
    forgotPasswordEvents.off('forgot-password-email-link-received', passwordResetCodeReceived);
});






</script>





<style scoped lang="scss">
.div {} // this is just a dummy class because the global styles are not applied if we don't have any styles in the file
</style>